import { FormControlLabel, Radio, RadioGroup, styled } from '@mui/material';

export const RadioStyled = styled(Radio)(({ theme }) => ({
  color: theme.palette.common.white,

  '&.Mui-disabled': {
    color: theme.palette.common.white,
  },

  '&.Mui-checked': {
    color: theme.palette.warning.main,
  },
}));

export const RadioGroupStyled = styled(RadioGroup)(({ theme }) => ({
  gap: '0.75rem',

  '&, & + .MuiFormControlLabel-label': {
    alignSelf: 'start',
  },

  [theme.breakpoints.up('sm')]: {
    flexDirection: 'column',
  },
}));

export const FormControlLabelStyled = styled(FormControlLabel)(({ theme }) => ({
  '&, & + .MuiFormControlLabel-label': {
    margin: 0,
  },
  '.MuiFormControlLabel-label.Mui-disabled': {
    color: theme.palette.common.white,
  },
}));
